import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canAccessRoute, normalizeRoutePath } from "../utils/authPermissions";
import CheckingAuthDialog from "./CheckingAuthDialog";

export default function ProtectedRoute({ children, path }) {
  const { isAuthenticated, isChecking, user } = useAuth();
  const location = useLocation();

  if (isChecking) {
    return <CheckingAuthDialog />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  const routePath = normalizeRoutePath(path || location.pathname);
  if (user?.role && !canAccessRoute(user.role, routePath)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
